/* eslint-disable no-use-before-define */
import { figure32_page4 } from '../../../../utils/constants';
import { TableDestin, Page } from '@orientaction/components';

const Page13 = (props: any) => {
  return (
    <Page id={13}>
      <TableDestin head={false} figure32={figure32_page4} />
    </Page>
  );
};

export default Page13;
